const endpoints = {
  listRemunerationsFixed: (): string => `remuneration/fixed`,
};

export default endpoints;
